<div class="blogs-cover">
  <div class="container">
    <div class="blogs-cover-widget d-flex">
      <h1>{{ "latest-news" | translate }}</h1>
      <img loading="lazy" src="/assets/images/blogs-img.svg" alt="blogs" />
    </div>
  </div>
</div>

<div class="blog">
  <div *ngIf="blog" class="container">
    <div class="blogs-container">
      <ng-container
        *ngTemplateOutlet="
          blogTemplate;
          context: { isArabic: currentLang === ApplicationLanguages.Ar }
        "
      >
      </ng-container>

      <ng-template #blogTemplate let-isArabic="isArabic">
        <div class="blog-data-container">
          <img
            loading="lazy"
            *ngIf="blog.img"
            class="blog-img"
            [src]="blog.img"
            [alt]="
              currentLang == ApplicationLanguages.Ar
                ? blog.titleAr
                : blog.titleEn
            "
          />
          <video *ngIf="blog.video" class="blog-img" controls>
            <source [src]="blog.video" />
          </video>

          <div class="blog-and-featured-two-blogs-container">
            <div>
              <div
                class="blog-data"
                [class.arabic-only-blog]="blog.isArabicOnly"
              >
                <h3>
                  {{
                    currentLang == ApplicationLanguages.Ar
                      ? blog.titleAr
                      : blog.titleEn
                  }}
                </h3>
                <div
                  class="html-content"
                  [innerHTML]="isArabic ? this.blog.descAr : this.blog.descEn"
                ></div>
              </div>

              <p class="blog-date">
                {{
                  currentLang == ApplicationLanguages.Ar
                    ? (blog.date
                      | date : "dd MMM yyyy" : "" : ApplicationLanguages.Ar)
                    : (blog.date | date : "dd MMM yyyy")
                }}
              </p>
            </div>

            <div class="featured-two-blogs-container">
              <ng-container *ngFor="let item of latestTwoBlogs; index as i">
                <app-blog [blog]="item" [isHome]="false"></app-blog>
              </ng-container>
            </div>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</div>
